/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuKeyWord } from './MktuKeyWord'
import {
  MktuKeyWordFromJSON,
  MktuKeyWordFromJSONTyped,
  MktuKeyWordToJSON,
} from './MktuKeyWord'

/**
 *
 * @export
 * @interface GetWords200Response
 */
export interface GetWords200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetWords200Response
   */
  status: boolean
  /**
   *
   * @type {Array<MktuKeyWord>}
   * @memberof GetWords200Response
   */
  data: Array<MktuKeyWord>
}

/**
 * Check if a given object implements the GetWords200Response interface.
 */
export function instanceOfGetWords200Response(
  value: object
): value is GetWords200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetWords200ResponseFromJSON(json: any): GetWords200Response {
  return GetWords200ResponseFromJSONTyped(json, false)
}

export function GetWords200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetWords200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(MktuKeyWordFromJSON),
  }
}

export function GetWords200ResponseToJSON(
  value?: GetWords200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(MktuKeyWordToJSON),
  }
}
